import httpClient from "@/services";
import { API_ENDPOINTS } from "@/services/endpoints";
import type { InviteUserRequest } from "@/types/invite-user";

export const inviteUser = async (request: InviteUserRequest) => {
  const url = API_ENDPOINTS.INVITE_USER;

  const payload = {
    member: request.member,
    employee: request.employee,
    group: request.group,
    firstname: request.firstname,
    lastname: request.lastname,
    email: request.email,
    loginGroupId: request.loginGroupId,
  };

  return httpClient.post(url, payload).then((response) => response.data);
};
